module.exports = __webpack_public_path__ + "static/media/sort.3e60bce0.svg";